import { useSortableContext } from '@app/components/various/Sortable/context/SortableContext';
import { isDefined } from '@app/utils/is';
import { Sortable } from '@typings';
import { useTranslation } from 'react-i18next';

export const useSortableAnnouncements = () => {
  const { t } = useTranslation(['accessibilityDescriptions']);

  const { activeAnnouncement, setActiveAnnouncement } = useSortableContext();

  const announceMovementChange = (item: Sortable.FlattenedItem, sortedItems: Sortable.FlattenedItem[]) => {
    const prevIndex = item.index;
    const currentIndex = sortedItems.find(({ id }) => id === item.id)?.index;
    const parentItem = sortedItems.find(({ id }) => id === item.parentId);

    if (isDefined(parentItem)) {
      setActiveAnnouncement(
        t('accessibilityDescriptions:item_moved_in_parent', {
          from: prevIndex,
          item: item.label ?? item.id,
          parent: parentItem.label ?? parentItem.id,
          to: currentIndex,
        }),
      );

      return;
    }

    setActiveAnnouncement(t('accessibilityDescriptions:item_moved', { from: prevIndex, item: item.label ?? item.id, to: currentIndex }));
  };

  const announceNestingChange = (item: Sortable.FlattenedItem, sortedItems: Sortable.FlattenedItem[]) => {
    const currentItem = sortedItems.find(({ id }) => id === item.id);
    const prevParentItemId = item.parentId;
    const currentParenItemId = currentItem?.parentId;

    if (!isDefined(currentItem)) {
      return;
    }

    if (!isDefined(currentParenItemId)) {
      const prevParent = sortedItems.find(({ id }) => id === prevParentItemId);

      setActiveAnnouncement(
        t('accessibilityDescriptions:item_moved_from_parent', {
          item: item.label ?? item.id,
          parent: prevParent?.label ?? prevParentItemId,
          position: currentItem.index,
        }),
      );

      return;
    }

    const currentParent = sortedItems.find(({ id }) => id === currentParenItemId);

    setActiveAnnouncement(
      t('accessibilityDescriptions:item_moved_to_parent', {
        item: item.label ?? item.id,
        parent: currentParent?.label ?? currentParenItemId,
        position: currentItem.index,
      }),
    );
  };

  return {
    activeAnnouncement,
    announceMovementChange,
    announceNestingChange,
  };
};
